import type { GetDeliveryReportTenantResponse } from './type'

type DeliveryReportTenant = GetDeliveryReportTenantResponse['data']

/**
 * 納品先表示名を「会社名+倉庫名+テナント名」で連結する（区切り文字なし）。
 * 会社名・倉庫名は紐づかないテナントで null になりうるため、存在する要素のみを連結する。
 */
export const formatDeliveryReportTenantName = (
  tenant: Pick<DeliveryReportTenant, 'companyName' | 'warehouseName' | 'tenantName'>
): string =>
  [tenant.companyName, tenant.warehouseName, tenant.tenantName]
    .filter((part): part is string => !!part?.trim())
    .join('')
